import classNames from "classnames"
import { Button } from "../../ui/Button/Button"
import { Icon } from "../../ui/Icon/Icon"
import { Text } from "../../ui/Text/Text"
import { useApp } from "../../../hooks/useApp"
import { getItemsNumber } from "./utils"
import { AddToCartButton } from "../AddToCartButton/AddToCartButton"
import { formatCentsToDollars } from "../../../utils/formatCentsToDollars"
import { getTotalPrice } from "../../../utils"

interface Props {
  className?: string
}

export const CartBar = ({ className }: Props) => {
  const { 
    mainProduct, 
    activeScreen, 
    setActiveScreen, 
    activeMainProductVariantId, 
    activePendantProductVariantIds, 
    setDesignSummaryPopupOpen,
    isMainProductSinglePendant
  } = useApp()
  
  const totalPrice = getTotalPrice(mainProduct, activeMainProductVariantId, activePendantProductVariantIds)
  const numberOfItems = getItemsNumber(activePendantProductVariantIds)

  const handleChainSelect = () => setActiveScreen('PENDANTS')

  return (
    <div className={classNames("flex gap-3 items-center justify-center", className)}>
      <div className="flex-grow flex items-center gap-2 p-2 bg-white rounded-sm shadow-lg">
        <Button className="!p-1.5 flex-shrink-0" size="sm" color="gray" onClick={() => setDesignSummaryPopupOpen(true)}>
          <Icon type="chevron-up" />
        </Button>

        <div className="flex gap-x-1 gap-y-0.5 flex-wrap"> 
          <p>
            <Text className="block h-[14px] leading-[14px] uppercase text-ink" style="label">Your {mainProduct.metafields.type ?? 'necklace'}</Text>
          </p>
          <p className="flex gap-1 flex-wrap">
            <Text className="leading-[14px] uppercase" style="label">({numberOfItems} items)</Text>
            <Text className="leading-[14px] uppercase" style="label">{formatCentsToDollars(totalPrice)}</Text>
          </p>
        </div>
 
      </div>

      {!isMainProductSinglePendant && activeScreen === 'CHAIN' ? (
        <Button className="!p-3 shadow-[0_10px_15px_-3px_rgba(0,0,0,0.50)]" size="md" color="black" onClick={handleChainSelect}>
          <Text style="label">Select</Text> 
        </Button>
      ) : ( 
        <AddToCartButton className="!py-[13px] min-w-[105px] shadow-[0_10px_15px_-3px_rgba(0,0,0,0.35)]" />
      )}
    </div>
  )
}
